import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabaseClient'
import useDocumentTitle from '../hooks/useDocumentTitle'
import {
  HiOutlineOfficeBuilding,
  HiOutlineUsers,
  HiOutlineKey,
  HiOutlineHome,
  HiOutlineMail,
} from 'react-icons/hi'

export default function DashboardPage() {
  useDocumentTitle('Dashboard')

  const [stats, setStats] = useState({
    totalAgencies: 0,
    totalProperties: 0,
    totalUsers: 0,
    totalKeys: 0,
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchStats() {
      try {
        const [agenciesRes, propertiesRes, usersRes, keysRes] =
          await Promise.all([
            supabase.from('agencies').select('id', { count: 'exact', head: true }),
            supabase.from('properties').select('id', { count: 'exact', head: true }),
            supabase.from('profiles').select('id', { count: 'exact', head: true }),
            supabase.from('keys').select('id', { count: 'exact', head: true }),
          ])

        setStats({
          totalAgencies: agenciesRes.count || 0,
          totalProperties: propertiesRes.count || 0,
          totalUsers: usersRes.count || 0,
          totalKeys: keysRes.count || 0,
        })
      } catch (err) {
        console.error('Error loading stats:', err)
      } finally {
        setLoading(false)
      }
    }
    fetchStats()
  }, [])

  const statCards = [
    {
      label: 'Total Agencies',
      value: stats.totalAgencies,
      icon: HiOutlineOfficeBuilding,
      color: 'primary',
      link: '/agencies',
    },
    {
      label: 'Total Properties',
      value: stats.totalProperties,
      icon: HiOutlineHome,
      color: 'success',
      link: '/agencies',
    },
    {
      label: 'Total Users',
      value: stats.totalUsers,
      icon: HiOutlineUsers,
      color: 'info',
      link: '/users',
    },
    {
      label: 'Total Keys',
      value: stats.totalKeys,
      icon: HiOutlineKey,
      color: 'danger',
      link: '/users',
    },
  ]

  return (
    <div className="dashboard-page">
      <div className="page-header">
        <div>
          <h1>Dashboard</h1>
          <p>Overview of your Kleezy platform</p>
        </div>
      </div>

      <div className="stats-grid">
        {statCards.map((card) => (
          <Link to={card.link} key={card.label} className={`stat-card ${card.color}`}>
            <div className="stat-card-icon">
              <card.icon />
            </div>
            <div className="stat-card-info">
              <span className="stat-card-label">{card.label}</span>
              <strong className="stat-card-value">
                {loading ? '–' : card.value}
              </strong>
            </div>
          </Link>
        ))}
      </div>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Quick Actions</h3>
          <div className="quick-actions">
            <Link to="/agency-requests" className="btn btn-primary">
              <HiOutlineMail />
              Agency Requests
            </Link>
            <Link to="/users" className="btn btn-secondary">
              <HiOutlineUsers />
              Manage Users
            </Link>
          </div>
        </div>

        <div className="dashboard-card">
          <h3>Platform Highlights</h3>
          <ul className="highlights-list">
            <li>
              <span className="highlight-dot success" />
              Agency management is fully operational
            </li>
            <li>
              <span className="highlight-dot success" />
              Key tracking system active
            </li>
            <li>
              <span className="highlight-dot warning" />
              Subscription management coming soon
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
